const UPDATE_SECTION_VISIBILITY =
  'platfi-ui-app/MONITOR_SHAREABLE_REPORT/UPDATE_SECTION_VISIBILITY';

export { UPDATE_SECTION_VISIBILITY };
